import React from "react";

const IFrame = ({ pagina }) => {
  return (
    <iframe
      title={pagina.url}
      src={pagina.url}
      style={{ width: "100%", minHeight: `calc(100vh - 90px)`, border: "none" }}
      allowFullScreen
    />
  );
};

export default IFrame;
